import { useWalletContext } from '@/contexts/WalletContext';

/**
 * Hook to access wallet functionality
 * Provides wallet connection status, address, and connection methods
 */
export const useWallet = () => {
  return useWalletContext();
};
